import Button from './Button.vue';

export default Button;



// WEBPACK FOOTER //
// ./src/components/parts/vacancies/card/components/btn/index.ts